import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { ColorInput } from 'app/shared/components/color-input/ColorInput';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { BoxForm, FormControlDefault, MenuItemStyled, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { ISensor } from 'app/shared/model/sensor.model';
import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { toast } from 'react-toastify';
import { createEntity, getEntity, reset, updateEntity } from './statistic-mark-line.reducer';

export const StatisticMarkLineUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const statisticMarkLineEntity = useAppSelector(state => state.statisticMarkLine.entity);
  const updateSuccess = useAppSelector(state => state.statisticMarkLine.updateSuccess);
  const loading = useAppSelector(state => state.statisticMarkLine.loading);
  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const [color, setColor] = useState(isNew && '#dc3545');
  const [sensor, setSensor] = useState<ISensor>(null);
  const [formData, setFormData] = useState({
    id: null,
    label: '',
    lineType: '',
    color: '#dc3545',
    sensor: null,
    value: null,
  });
  const lineTypesOptions = ['solid', 'dashed', 'dotted'];
  const valueNameForms = 'value';

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (!isNew && statisticMarkLineEntity) {
      setFormData({
        id: statisticMarkLineEntity?.id,
        label: statisticMarkLineEntity?.label,
        lineType: statisticMarkLineEntity?.lineType,
        color: statisticMarkLineEntity?.color,
        sensor: statisticMarkLineEntity?.sensor,
        value: statisticMarkLineEntity?.value,
      });
    }
  }, [statisticMarkLineEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (statisticMarkLineEntity && !isNew) {
      setSensor(statisticMarkLineEntity?.sensor);
    }
  }, [statisticMarkLineEntity]);

  const saveEntity = values => {
    color ? (values.color = color) : values.color;
    const entity = {
      ...statisticMarkLineEntity,
      ...values,
      sensor: values?.sensor || sensor,
    };

    if (!entity?.sensor?.id) {
      return toast.error('Necessário selecionar um sensor.');
    }

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleClose = () => {
    props.history.goBack();
  };

  const handleColorChange = value => {
    setColor(value);
    handleInputChange('color', value);
  };

  const handleSubmit = () => {
    event.preventDefault();
    saveEntity(formData);
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.statisticMarkLine'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    {!isNew && (
                      <FormControlDefault sx={{ display: 'none' }}>
                        <TypographyForms>{translate('global.field.id')}</TypographyForms>
                        <TextFieldForms value={formData['id']} id={'statistic-mark-line-id'} name={'id'} />
                      </FormControlDefault>
                    )}
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.statisticMarkLine.label')}</TypographyForms>
                      <TextFieldForms
                        value={formData['label']}
                        id={'statistic-mark-line-label'}
                        data-cy={'label'}
                        name={'label'}
                        required={true}
                        onChange={e => handleInputChange('label', e.target.value)}
                      />
                    </FormControlDefault>
                    <FormControlDefault>
                      <SelectPaginate
                        label={translate('fleetSenseApp.alert.sensor')}
                        apiUrl={'api/allSensorsListWithPagination'}
                        onChange={value => handleInputChange('sensor', value)}
                        value={formData['sensor']}
                        valueName="name"
                        icon="sort-down"
                        isRequired={true}
                        statusFilter
                        filterStyle={true}
                      />
                    </FormControlDefault>
                    <FormControlDefault>
                      <TypographyForms>{translate('fleetSenseApp.statisticMarkLine.value')}</TypographyForms>
                      <TextFieldForms
                        value={formData['value']}
                        id={'statistic-mark-line-value'}
                        name={valueNameForms}
                        data-cy={'value'}
                        required={true}
                        onChange={e => handleInputChange('value', e.target.value)}
                        type="number"
                      />
                    </FormControlDefault>
                    <FormControlDefault>
                      <Box display={'flex'} sx={{ ':-ms-input-placeholder': { color: formData['color'] } }}>
                        <Box width={'100%'}>
                          <TypographyForms>{translate('fleetSenseApp.statisticMarkLine.lineType')}</TypographyForms>
                          <TextFieldForms
                            fullWidth
                            fontSize={'1.5rem'}
                            value={formData['lineType'] || ''}
                            onChange={e => handleInputChange('lineType', e.target.value)}
                            select
                            required={true}
                            id={'statistic-mark-line-lineType'}
                            name={'lineType'}
                            data-cy="lineType"
                            sx={{
                              '.MuiSelect-select': {
                                color: formData['color'],
                                minHeight: '0px !important',
                                fontSize: '36px',
                              },
                              '& .MuiInputBase-input': {
                                padding: '0px 16px 20px 16px',
                              },
                            }}
                          >
                            {lineTypesOptions.map(option => (
                              <MenuItemStyled key={option} value={option} style={{ paddingBottom: '20px' }}>
                                <div style={{ borderBottom: `4px ${option} ${formData['color']}`, width: '50%', paddingBottom: '20px' }} />
                              </MenuItemStyled>
                            ))}
                          </TextFieldForms>
                        </Box>
                        <Box width={'55px'} borderRadius={'25px'} ml={'5px'}>
                          <TypographyForms>{translate('fleetSenseApp.statisticMarkLine.color')}</TypographyForms>
                          <ColorInput
                            value={formData['color'] ? formData['color'] : 'red'}
                            onChange={handleColorChange}
                            name="color"
                            id="statistic-mark-line-color"
                            data-cy="color"
                            fullWidth
                          />
                        </Box>
                      </Box>
                    </FormControlDefault>
                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </div>
  );
};
